import axios from "axios";

const apiurl = process.env.REACT_APP_API_URL;

export const GetAndCreateAddProducts = async(method,data)=>{
    return axios({
        method:method,                                         // This is used to get and post Add Products data from API
        url:`${apiurl}LADProducts/add-products/`,
        data:data
    })
}

export const GetAndCreateAssignedToMails = async(method,data)=>{
    return axios({
        method:method,                                         // This is used to get and post Add Products data from API
        url:`${apiurl}LADProducts/assingtoemail/`,
        data:data
    })
}

